import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TrafficSignIcon } from '@fronton/icons-react';
import { analyticsUtils } from 'utils';
import { getStoreDetail } from 'features/store/ducks/get-store-by-id';
import { RouteBlock } from 'features/store-common-info/store-routes/route-block';
import { HowToGetTo } from 'features/store-common-info/store-routes/how-to-get-to';
import { getTitle } from 'features/page-model/ducks/get-model';
import { StoreRoutesContainer } from './styles';

export const StoreRoutes: FC = () => {
  const { t } = useTranslation();
  const { geocoordinateLongitude: long, geocoordinateLatitude: lat } = useSelector(getStoreDetail) || {};
  const title = useSelector(getTitle);
  const buildRoute = t('buildRoute');

  const navigateToMap = useCallback(() => {
    window.open(`https://maps.yandex.ru/?rtext=~${lat},${long}`, '_blank');

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage', // блок, в котором расположен элемент
      elementName: title, // название блока
      elementText: buildRoute, // текст кнопки (Как добраться транспортом, Товары в магазине, План магазина, Фото магазина)
    });
  }, [lat, long, title, buildRoute]);
  return (
    <StoreRoutesContainer data-qa="route-block">
      {long && lat && (
        <RouteBlock
          label={buildRoute}
          icon={<TrafficSignIcon size="xl" type="outline" />}
          iconActive={<TrafficSignIcon size="xl" type="duotone" />}
          onClick={navigateToMap}
          qa="transport-info"
        />
      )}
      <HowToGetTo />
    </StoreRoutesContainer>
  );
};
